import React from 'react';
import { Link } from 'react-router-dom';
import WithConsumer from '../context/WithConsumer';
// import PostMeta from './PostMeta';
// import BackLink from './BackLink';
import { Helmet } from 'react-helmet';
// import TwitterFeed from'../partials/TwitterFeed'
// import AdSense from 'react-adsense';
// import SiteMap from './SiteMap';

const ThePost = ({index,context}) => {

    const posts = () => context.posts;
    const item = posts()[index];
    const bIsHomepage = context.restType === 'home' ? true : false;
    const bIsSitemap = context.restType === 'sitemap' ? true : false;
    const bIsPrivacy = context.slug === 'privacy-policy' ? true : false;

    // Convert html strings
    // const renderHTML = (rawHTML: string) => React.createElement("span", { dangerouslySetInnerHTML: { __html: rawHTML } });

    function shortenExcerpt(text, count){
        var StrippedString = text.replace(/(<([^>]+)>)/ig,"");

        return StrippedString.slice(0, count) + (StrippedString.length > count ? "..." : "");
    }

    // let metaTitle = item.title.rendered + ' - James Fawcett';
    // let metaDescription = item.excerpt;
    // const shorterExcerpt = item.excerpt.substr(0,155);
    // console.log('item:', item);

    // if (item.yoast_meta.hasOwnProperty('yoast_wpseo_title')) {
    //     console.log('HAS META TITLE');
    // }
    
    let metaTitle = item.yoast_meta && item.yoast_meta.hasOwnProperty('yoast_wpseo_title') ? item.yoast_meta.yoast_wpseo_title : item.title.rendered + ' - James Fawcett';
    let metaDescription = item.yoast_meta && item.yoast_meta.hasOwnProperty('yoast_wpseo_metadesc') ? item.yoast_meta.yoast_wpseo_metadesc : shortenExcerpt(item.excerpt.rendered, 150);

    if (bIsSitemap === true) {
        metaTitle = 'Sitemap - jamesfawcett.co.uk';
        metaDescription = 'Sitemap - list of all pages';
    }

    let HeadingCase = context.slug === item.slug ? "h1" : "h2";

    if ( bIsSitemap === true) {
        HeadingCase = "span";
        
    }

    // let linkPrefix = item.type === 'page' ? '/page/' : '/post/';
    let linkPrefix = item.type === 'page' ? '/page/' : '/';
    // let linkPrefix = '/';

    let theContent = '';

    switch(context.route){
        case '/': //if homepage,
            theContent = item.content.rendered; // Mod
        break;
        case '/search/:term': //or if search
        case '/category/:catid': //or if cat
            theContent = item.excerpt.rendered; //show excerpt only
        break;
        default: //for single, pages - show entire content
            // if (bIsSitemap) {

            //     theContent = ''; //show excerpt only
            // } else {
            theContent = item.content.rendered;
            // }
        break;
    }

    // function slugLinkClicked(){
    //     context.slugLinkClicked();
    // }

    // console.log('theContent:', theContent);
    // Missing postmeta:
    // {/*<PostMeta index={index}></PostMeta>*/}

    return (
        <div id={'post-id-'+item.id} className={'post-item'}>

            <Helmet>
              <title>{metaTitle}</title>
              <meta charSet="utf-8" />
              <meta name="description" content={metaDescription} />
            </Helmet>

            { (bIsHomepage === true) ? (
                <HeadingCase>{item.title.rendered}</HeadingCase>
            ) : (
                <Link to={linkPrefix+item.slug+'/'}><HeadingCase>{item.title.rendered}</HeadingCase></Link>
            )}
            

            {( bIsSitemap !== true) && (
                <div className="post-content" dangerouslySetInnerHTML={{__html:theContent}}></div>
            )}

            {/* {( bIsHomepage === true) && (
                <TwitterFeed />
            )} */}

            {/* {(bIsHomepage !== true && bIsSitemap !== true && bIsPrivacy !== true) && (
                // responsive and native ads
                // <AdSense.Google
                //     client='ca-pub-3276901794463124'
                //     slot='1263379328'
                //     style={{ display: 'block' }}
                //     layout='in-article'
                //     format='auto'
                // />
            )} */}

        </div>);

};
export default WithConsumer(ThePost);